module.exports = __webpack_public_path__ + "static/media/hebebühne_schema.4f6b5ed5.jpg";